/**
 * Created by josh on 2017/8/11.
 */

import Button from '../packages/button/index.js';
import ButtonGroup from '../packages/button-group/index.js';
import ButtonCheckbox from '../packages/button-checkbox/index.js';

const publicComponents = [
    Button,
    ButtonGroup,
    ButtonCheckbox
];
const install = function(Vue, opts = {}) {
    /* istanbul ignore if */
    if (install.installed) {
        return false;
    }
    install.installed = true;

    publicComponents.map(component => {
        Vue.component(component.name, component);
    });
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
};

export {
    install,
    Button,
    ButtonGroup,
    ButtonCheckbox
};


// WEBPACK FOOTER //
// ./src/plugin-api/src/index.js